import "@/styles/index.scss";

import CartManager from "./components/cart";
import MenuToggle from "./components/menu";
import ScrollHeader from "@/app/components/header";
import QuoteGenerator from "@/app/components/quoteGenerator";
import ToTheTop from "@/app/components/toTheTop";
import LazyLoad from "@/app/components/lazyLoad";
import LoadMore from "@/app/components/loadMore";
import ProductFilter from "@/app/components/productFilter";
import ProductImageCarousel from "@/app/components/productImageCarousel";

import Swup from "swup";
import SwupBodyClassPlugin from "@swup/body-class-plugin";
import SwupScriptsPlugin from "@swup/scripts-plugin";

const options = {
  plugins: [new SwupBodyClassPlugin(), new SwupScriptsPlugin()],
};

const swup = new Swup(options);

const HMH = {
  init() {
    if (document.getElementById("clouds-container")) {
      new QuoteGenerator(quotes, "quote", "next-quote", "clouds-container");
    }

    new CartManager();
    
    const backToTop = new ToTheTop({ 
      buttonId: "btnTop",
      scrollOffset: 50,
      smoothScroll: true
    });

    backToTop.init();

    new ScrollHeader("header");
    new MenuToggle("menuButton", "menuClose", "menu", "body", "overlay");
    
    // Initialize lazy loading for products
    const lazyLoad = new LazyLoad('.lazy-load-product', {
      rootMargin: '100px 0px',
      threshold: 0.1,
      animationDelay: 30  // Reduced delay for faster animations
    });
    
    // Initialize product category filter
    if (document.querySelector('#product-category-filter')) {
      const productFilter = new ProductFilter({
        filterSelector: '#product-category-filter',
        productSelector: '.product-item',
        containerSelector: '.products-grid',
        lazyLoadInstance: lazyLoad
      });
    }
    
    // Initialize load more functionality
    if (document.querySelector('.load-more-btn')) {
      const loadMore = new LoadMore({
        containerSelector: '.products-grid',
        buttonSelector: '.load-more-btn',
        loadingSelector: '.load-more-loading',
        endpoint: '/api/products/load-more',
        limit: 8
      });
      
      // Connect lazy load instance to load more for new products
      loadMore.setLazyLoadInstance(lazyLoad);
    }
    
    // Initialize product image carousel
    if (document.querySelector('.product-image-carousel')) {
      new ProductImageCarousel('.product-image-carousel');
    }
  }
}

document.addEventListener("DOMContentLoaded", () => HMH.init());
swup.hooks.on("page:view", () => HMH.init());

console.log("%c Developed by ANTI - https://anti.as/", "background: #000; color: #fff;");